<template>
    <div class="qoute-step">
        <form style="min-width:50%;height:320px;margin:50px;overflow-y:auto;">
            <!-- One "tab" for each step in the form: -->

            <div v-show="step && step == 1" class="tab" style="margin-bottom: 20px;">
                <h5>Who do you need?</h5>
                <category-selector category_type="task" v-model="category_id"></category-selector>
            </div>

            <div v-show="step && step == 2" class="tab">
                <h5>Quickly describe the job you need done</h5>
                <p>
                    <textarea v-model="description" class="form-control" placeholder="Enter job description"></textarea>
                </p>
            </div>

            <div v-show="step && step == 3" class="tab">
                <h5>Where do you need the job done?</h5>
                <p>
                    <suburb place_holder="Enter a postcode suburb" v-model="suburb_id"></suburb>
                </p>
                <h5>When do you need the job done?</h5>
                <p>
                    <task-execution-date
                            place_holder="Select the job execution time"
                            v-model="task_execution_date_id"
                    ></task-execution-date>
                </p>
            </div>

            <div v-show="step && step == 4" class="tab">
                <h5>What is your budget?</h5>
                <!-- <form class="form-inline"> -->
                <budget
                        container_class
                        div_class="col-md-12 budget-fsar"
                        label_class
                        input_class
                        container_style
                        div_style
                        label_style="width: 100%;margin-bottom:0;padding-bottom: 8px;"
                        input_style="width: 20px;float: left;margin-right: 5px; "
                        hr_style
                        hr_class
                        v-model="budget_id"
                ></budget>
            </div>

            <div v-show="step && step == 5" class="tab">
                <h5 class="mt-5">Attach your files <span v-show="attachment.length > 0">(Click on <strong>x</strong> to remove attachment )</span>
                </h5>
                <file-pond
                        name="test"
                        ref="pond"
                        v-model="attachment"
                        label-idle="Drop files here..."
                        v-bind:allow-multiple="true"
                        :files="attachment"
                        maxFileSize="20MB"
                />
            </div>
        </form>
        <div style="margin: 5px 40px;">
            <div style="margin: 0px auto;bottom: 5px;right: 70px;position: absolute;">
                <button
                        v-if="step > 1"
                        type="button"
                        id="prevBtn"
                        class="ps-btn ps-btn--sm"
                        @click="prev"
                >Previous
                </button>
                <button
                        v-if="step < 5"
                        type="button"
                        id="nextBtn"
                        class="ps-btn ps-btn--sm"
                        @click="next"
                >Next
                </button>
                <button
                        v-if="step == steps.length && showPostBtn"
                        type="button"
                        id="nextBtn"
                        class="ps-btn ps-btn--sm ps-btn--gradient btn-fsdfh"
                        @click="post"
                >Update
                </button>
            </div>
        </div>

        <!-- Circles which indicates the steps of the form: -->
        <div style="text-align:center;">
            <span class="step" :class="{ 'active finish': step == 1 }"></span>
            <span class="step" :class="{ 'active finish': step == 2 }"></span>
            <span class="step" :class="{ 'active finish': step == 3 }"></span>
            <span class="step" :class="{ 'active finish': step == 4 }"></span>
            <span class="step" :class="{ 'active finish': step == 5 }"></span>
        </div>
    </div>
</template>

<script>

    // Import Vue FilePond
    import vueFilePond from "vue-filepond";

    // Import FilePond styles
    import "filepond/dist/filepond.min.css";

    // Import image preview and file type validation plugins
    import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
    import FilePondPluginFileEncode from "filepond-plugin-file-encode";
    import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';

    const FilePond = vueFilePond(
        FilePondPluginFileValidateType,
        FilePondPluginFileEncode,
        FilePondPluginFileValidateSize
    );

    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";

    import CategorySelector from "./../../CategorySelector";
    import Suburb from "./../../Suburb";
    import Money from "./../../Money";
    import TaskExecutionDate from "./../../TaskExecutionDate";
    import Budget from "./../../Budget";

    export default {
        name: "edit-task",
        components: {
            Loading,
            CategorySelector,
            Suburb,
            Money,
            TaskExecutionDate,
            Budget,
        },
        props: {
            task: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                isModalVisible: false,
                showPostBtn: true,
                word: {},
                text: {},
                loading: false,
                step: 1,
                category_id: null,
                budget_id: null,
                description: null,
                suburb_id: null,
                task_execution_date_id: null,
                attachment: [],
                steps: [
                    "select a category",
                    "title & description",
                    "suburb & execution time",
                    "budget",
                    "attachments"
                ]
            };
        },
        created() {
            this.word = window.word;
            this.word = window.word;
            this.Task = this.task;
            this.category_id = this.Task.category_id;
            this.budget_id = this.Task.budget_id;
            this.description = this.Task.description;
            this.suburb_id = this.Task.suburb_id;
            this.task_execution_date_id = this.Task.task_execution_date_id;
            this.attachment = this.Task.attachments;
        },
        methods: {
            prev: function () {
                if (this.step > 1) {
                    this.step--;
                }
            },
            next: function () {
                if (this.step < this.steps.length) {
                    switch (this.step) {
                        case 1:
                            if (this.category_id != null) {
                                this.step++;
                            } else {
                                this.$toast.error("Select a category");
                            }
                            break;
                        case 2:
                            if (this.description != null && this.description.length >= 15) {
                                this.step++;
                            } else {
                                if (!this.description || this.description.length == 0) {
                                    this.$toast.error("Enter job description");
                                    return;
                                }
                                if (this.description.length < 15) {
                                    this.$toast.error("Description must be at least 15 character");
                                }
                            }
                            break;
                        case 3:
                            if (this.suburb_id != null && this.task_execution_date_id != null) {
                                this.step++;
                            } else {
                                this.$toast.error("set suburb & execution times");
                            }
                            break;
                        case 4:
                            if (this.budget_id != null) {
                                this.step++;
                            } else {
                                this.$toast.error("set budget");
                            }
                            break;
                        case 5:
                            let hasAttachmentError = 0;
                            if (this.newAttachment.length > 0) {
                                this.newAttachment.forEach(function (attach) {
                                    if (attach.status === 8) {
                                        hasAttachmentError++;
                                    }
                                });

                                if (hasAttachmentError !== 0) {
                                    this.$toast.error("Invalid Files", {
                                        queue: true
                                    });
                                } else {
                                    this.step++;
                                }
                            } else {
                                this.step++;
                            }
                            break;
                    }
                }
            },
            show() {
                this.isModalVisible = true;
            },
            hide() {
                this.isModalVisible = false;
            },
            post() {
                this.$Progress.start();
                this.showPostBtn = false;
                let self = this;

                let attachment = [];
                if (this.attachment.length > 0) {
                    this.attachment.forEach(function (attach) {
                        let attachmentItem = {};
                        attachmentItem.name = attach.file.name;
                        attachmentItem.size = attach.file.size;
                        attachmentItem.type = attach.file.type;
                        attachmentItem.data = attach.getFileEncodeDataURL();
                        attachment.push(attachmentItem);
                    });
                }

                let data = {
                    description: self.description,
                    category_id: self.category_id,
                    task_execution_date_id: self.task_execution_date_id,
                    budget_id: self.budget_id,
                    suburb_id: self.suburb_id,
                    attachment: attachment,
                };

                axios({
                    method: "post",
                    url: "/dashboard/task/" + self.Task.id + "?_method=patch",
                    data
                })
                    .then(function (res) {
                        self.$Progress.finish();
                        if (res.data.ok) {
                            self.$toast.success(res.data.msg);
                            setTimeout(() => {
                                location.replace("/dashboard/task");
                            }, 2000);
                        } else {
                            self.$Progress.fail();
                        }
                    })
                    .catch(function (e) {
                        self.$Progress.fail();
                        if (e.response.status == 422) {
                            self.errors = e.response.data.errors;
                            console.log(self.errors);
                            for (let error in self.errors) {
                                self.$toast.error(self.errors[error][0]);
                            }
                        } else {
                            console.log(e);
                        }
                    });
            }
        }
    };
</script>
<style>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }
</style>
